import {Inject, Injectable} from '@angular/core';
import {SYNC_SERVICE} from '../../shared/upgrade/sync.service';
import {NotificationsService} from './notifications.service';

export interface ParsedStartWorkEmployeeTime {
	employeeStartWorkHours: number;
	employeeStartWorkMinutes: number;
}
export interface ParsedFinishWorkEmployeeTime {
	employeeFinishWorkHours: number;
	employeeFinishWorkMinutes: number;
}


@Injectable()
export class WorkingTimeService {

	accountedTimePercents: number = 0;
	accountedTimeMinPercents: number = 75;
	workingTime: number = 0;

	constructor(private notificationsService: NotificationsService,
				@Inject(SYNC_SERVICE) private syncService: any) {
		syncService.addController('WorkingTimeNotificationsController');
	}

	parseEmployeeStartWorkTime(time: string): ParsedStartWorkEmployeeTime {
		const result: ParsedStartWorkEmployeeTime  = {
			employeeStartWorkHours: 0,
			employeeStartWorkMinutes: 0
		};


		let isAm: boolean;

		if (!time) {
			isAm = false;
		}

		if (time.search('am') !== -1) {
			isAm = true;
		}

		time = time.replace('am', '').replace('pm', '');

		const hoursAndMinutes: string[] = time.split(':');
		result.employeeStartWorkHours = isAm ? parseInt(hoursAndMinutes[0], 10) : parseInt(hoursAndMinutes[0], 10) + 12;

		if (hoursAndMinutes.length === 1) {
			result.employeeStartWorkMinutes = 0;
		} else {
			result.employeeStartWorkMinutes = parseInt(hoursAndMinutes[1], 10);
		}

		return result;
	}
	parseEmployeeFinishWorkTime(time: string): ParsedFinishWorkEmployeeTime {
		const result: ParsedFinishWorkEmployeeTime = {
			employeeFinishWorkHours: 0,
			employeeFinishWorkMinutes: 0
		};


		let isAm: boolean;

		if (!time) {
			isAm = false;
		}

		if (time.search('am') !== -1) {
			isAm = true;
		}

		time = time.replace('am', '').replace('pm', '');

		const hoursAndMinutes: string[] = time.split(':');
		result.employeeFinishWorkHours = isAm ? parseInt(hoursAndMinutes[0], 10) : parseInt(hoursAndMinutes[0], 10) + 12;

		if (hoursAndMinutes.length === 1) {
			result.employeeFinishWorkMinutes = 0;
		} else {
			result.employeeFinishWorkMinutes = parseInt(hoursAndMinutes[1], 10);
		}

		return result;
	}


}



// WEBPACK FOOTER //
// ./src/app/my-time/notifications/working-time.service.ts